import { Slot } from "@-/com.npmjs.expo-router";
import { LearningStatsToolbar } from "@-/dev.improve.haniverse.routes.nav.app.stats._components.toolbar";
import { View } from "@-/com.npmjs.react-native";
import { PrimaryControlsStripBack } from "@-/dev.improve.haniverse.routes.nav._components.primary-controls-strip.back";
import { FrostedBackdropTarget } from "@-/dev.improve.haniverse.components.ui.frosted-surface";

export function LearningStatsLayout() {
  return (
    <View className="flex-1 bg-background">
      <PrimaryControlsStripBack hidden />
      <LearningStatsToolbar />
      <FrostedBackdropTarget className="flex-1">
        <Slot />
      </FrostedBackdropTarget>
    </View>
  );
}
